import { render, staticRenderFns } from "./TokensSwapButton.vue?vue&type=template&id=1abf7954"
import script from "./TokensSwapButton.vue?vue&type=script&lang=ts"
export * from "./TokensSwapButton.vue?vue&type=script&lang=ts"
import style0 from "./TokensSwapButton.vue?vue&type=style&index=0&id=1abf7954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports